export default {
  pageTitle: 'マッフル製作',
  metaDescription: 'TEFは耐熱合金を用いて、熱処理用途向けの産業用マッフルおよび炉部品を製作しています。',
  sidebar: {
    title: '製作リスト',
    vessel: 'ベッセル製作',
    heatExchanger: '熱交換器製作',
    piping: '配管製作',
    tower: '塔槽製作',
    muffle: 'マッフル製作',
    radiantTube: 'ラジアントチューブ製作',
    otherEquipment: 'その他設備製作',
  },
  fabricationOf: '製作',
  product: {
    name: 'マッフル',
    desc: '以下は、当社のマッフル製作における各種材質・タイプ・仕様の実績カタログです。',
  },
};
